import gsap          from 'gsap'
import Observer      from 'gsap/Observer'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitText     from 'gsap/SplitText'

const windowGSAP = {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		gsap.registerPlugin(SplitText)
		gsap.registerPlugin(Observer)

		// ScrollTrigger.clearScrollMemory('manual')

		window.gsap          = gsap
		window.ScrollTrigger = ScrollTrigger
		window.Observer      = Observer
	},
}

export default windowGSAP
